var map = {
	"./symbol_0.png": 46680,
	"./symbol_1.png": 14945,
	"./symbol_2.png": 65962,
	"./symbol_3.png": 21171,
	"./symbol_4.png": 21212,
	"./symbol_5.png": 50629,
	"./symbol_6.png": 78830
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6123;